import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeFormat'
})
export class TimeFormatPipe implements PipeTransform {

  transform(value: string | number): string {
      if (!value) return '';

      let horas = '00';
      let minutos = '00';

      // Caso 1: string no formato "HH:mm:ss"
      if (typeof value === 'string' && /^\d{2}:\d{2}(:\d{2})?$/.test(value)) {
        const parts = value.split(':');
        horas = parts[0] || '00';
        minutos = parts[1] || '00';
      } 
      // Caso 2: ISO date ou timestamp
      else {

        const dateStr = value.toString();

        const [h, m] = dateStr.slice(11, 16).split(':');

        horas = h;
        minutos = m;
      }

      return `${horas}:${minutos}`;
    }

}
